import { Route, RouteGroup } from '@billow/easy-route'
import { view } from '@/utilities/view'

export default RouteGroup({

  prefix: '/site',

  routes: [
    Route('/navigation', 'site.navigation', view('site/Navigation')),
    Route('/navigation/create/:navItem?', 'site.newNavigation', view('site/NewNavigation')),
    Route('/navigation/:navItem/edit', 'site.editNavigation', view('site/EditNavigation'))
  ]
})